"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleBar = void 0;
const pdfTheme_1 = require("../pdfTheme");
const fontSize = pdfTheme_1.pdfTheme.font.size.default;
class TitleBar {
    constructor(collectionTitle, jobName, currentPoleIndex, totalPoles, pageBreak) {
        this.collectionTitle = collectionTitle;
        this.jobName = jobName;
        this.currentPoleIndex = currentPoleIndex;
        this.totalPoles = totalPoles;
        // if the title wraps to a second line, this will break
        this.height = fontSize * pdfTheme_1.MAGIC_SCALING_NUMBER + pdfTheme_1.pdfTheme.spacing.default * 2;
        this.pageBreak = pageBreak === 'none' ? undefined : pageBreak;
    }
    exportContent() {
        return {
            pageBreak: this.pageBreak,
            fillColor: pdfTheme_1.pdfTheme.background.default,
            layout: {
                paddingTop: () => pdfTheme_1.pdfTheme.spacing.default,
                paddingBottom: () => pdfTheme_1.pdfTheme.spacing.default,
                paddingLeft: () => pdfTheme_1.pdfTheme.spacing.default,
                paddingRight: () => pdfTheme_1.pdfTheme.spacing.default,
                defaultBorder: false,
                hLineWidth: () => 0,
                vLineWidth: () => 0
            },
            margin: [0, 0],
            // we use tables because it's the easiest way to get backgrounds that span the entire width
            table: {
                widths: ['auto', '*'],
                body: [
                    [{ text: `Job: ${this.jobName}`, style: ['text', 'left'], margin: 0 },
                        {
                            text: `${this.collectionTitle} (${this.currentPoleIndex} of ${this.totalPoles})`,
                            style: ['text', 'right'],
                            margin: 0
                        }]
                ]
            }
        };
    }
    exportStyles() {
        return {
            text: {
                fontSize,
                bold: true,
                color: pdfTheme_1.pdfTheme.font.color.dark
            },
            left: {
                alignment: 'left'
            },
            center: {
                alignment: 'center'
            },
            right: {
                alignment: 'right'
            }
        };
    }
}
exports.TitleBar = TitleBar;
//# sourceMappingURL=TitleBar.js.map